import { createApp } from 'vue';
import i18n from '@/locales/i18n';

import Toast, { PluginOptions, POSITION } from 'vue-toastification';
import * as Sentry from '@sentry/vue';

import App from './App.vue';
import router from './router';
import { store } from '@/mw-components/store';
import './scss/main.scss';
import 'vue-toastification/dist/index.css';
import { getEnv } from '@/plugin/functions';

const mw = createApp(App);

const options: PluginOptions = {
  position: POSITION.BOTTOM_RIGHT,
  timeout: 5000,
};

console.log(`Vite Env: ${import.meta.env.MODE}
  Run Env: ${getEnv()}`);

Sentry.init({
  app: mw,
  dsn: 'https://f1bcea846e4524e2699d3aa5f37ce0fd@o4507888145465344.ingest.de.sentry.io/4507928862851152',
  sendDefaultPii: false,
  environment: getEnv(),
  integrations: [
    // Enable performance monitoring for browser navigation and route changes
    Sentry.browserTracingIntegration({ router }),
    // Enable replay recording for user sessions
    Sentry.replayIntegration(),
  ],
  replaysOnErrorSampleRate: 1.0, // Capture 100% of errors with replays
  replaysSessionSampleRate: 0, // Disable replays for other sessions
  enabled: getEnv() === 'production', // Only enable in production

  // Enable this if we want to trace through the stack (but check URLs first)
  // tracePropagationTargets: [
  //   'https://interface.liftshare.com',
  //   'https://interface-dev.liftshare.com',
  //   'https://interface-staging.liftshare.com',
  // ],

  // tracesSampleRate: 0.1, // Enable performance monitoring when ready
});

mw.use(router);
mw.use(store);
mw.use(Toast, options);
mw.use(i18n);

mw.mount('#app');
